import { render, staticRenderFns } from "./editSubject.vue?vue&type=template&id=25492d16"
import script from "./editSubject.vue?vue&type=script&lang=js"
export * from "./editSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports